import assign from 'object-assign';
import {currencyToFloat} from '@util/NumberUtil';
import {getAnalyticsCurrency, getLineTotals} from '@upi/data-layer-utils';

export const FBQCustomEvent = {
    ADD_TO_CART: 'AddToCart',
    HOMEPAGE_VIEW: 'ViewContent',
    PRODUCT_VIEW: 'ProductView',
    FIND_DENTIST_VIEW: 'FindLocation',
    INIT_CHECKOUT: 'InitiateCheckout',
    ADD_PAYMENT: 'AddPaymentInfo',
    PURCHASE: 'Purchase',
    NEWSLETTER_REGISTRATION: 'CompleteRegistration'
};

const facebookPixelProto = {
    send ( eventName, data = {} ) {
        if ( !window.fbq ) {
            window.fbq = function ( fbqAction, eventName, data ) {
                console.warn( `[Facebook Pixel] - NOT implemented, ignoring tracking event "${eventName}"`, data );
            };
        }

        window.fbq( 'trackCustom', eventName, data );
        return this;
    },

    createProductData ( item ) {
        return {
            id: item.sku,
            price: parseFloat( item.customerPrice || item.catalogPrice || 0 ),
            name: item.kitName,
            brand: item.brandName || item.productName,
            category: item.productFamily,
            quantity: item.quantity || 1
        };
    }
};

export const facebookPixelLayer = assign( {}, facebookPixelProto, {
    itemsAdded ( items = [] ) {
        if ( !Array.isArray( items ) ) {
            items = [items];
        }

        items.forEach( item => {
            const data = this.createProductData( item );
            this.send( FBQCustomEvent.ADD_TO_CART, data );
        } );
    },

    newsletterRegistration () {
        this.send( FBQCustomEvent.NEWSLETTER_REGISTRATION );
    },
    purchaseComplete ( items = [] ) {
        const products = items.map( this.createProductData );
        let parsedValue = getLineTotals( products );
        parsedValue = currencyToFloat( parsedValue );
        parsedValue = isNaN( parsedValue ) ? 0 : parsedValue;
        this.send( FBQCustomEvent.PURCHASE, {
            value: parsedValue,
            currency: getAnalyticsCurrency( items )
        } );
    },
    productView: function ( item ) {
        const data = this.createProductData( item );
        this.send( FBQCustomEvent.PRODUCT_VIEW, data );
    },
    viewHomepage () {
        this.send( FBQCustomEvent.HOMEPAGE_VIEW );
    },
    viewCart () {
        this.send( FBQCustomEvent.INIT_CHECKOUT );
    }
} );
